import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { hasNamespace, useContextSystem } from '@wp-g2/context';
import { css, cx, ui } from '@wp-g2/styles';
import { getValidChildren } from '@wp-g2/utils';
import React, { useMemo } from 'react';
import { FlexItem, useFlex } from '../Flex';
import { getAlignmentProps } from './HStack.utils';
export function useHStack(props) {
  var _useContextSystem = useContextSystem(props, 'HStack'),
      _useContextSystem$ali = _useContextSystem.alignment,
      alignment = _useContextSystem$ali === void 0 ? 'edge' : _useContextSystem$ali,
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      direction = _useContextSystem.direction,
      _useContextSystem$spa = _useContextSystem.spacing,
      spacing = _useContextSystem$spa === void 0 ? 2 : _useContextSystem$spa,
      otherProps = _objectWithoutProperties(_useContextSystem, ["alignment", "children", "className", "direction", "spacing"]);

  var align = getAlignmentProps(alignment, direction);
  var validChildren = getValidChildren(children);
  var clonedChildren = validChildren.map(function (child, index) {
    var _key = child.key || "hstack-" + index;

    var _isSpacer = hasNamespace(child, ['Spacer']);

    if (_isSpacer) {
      return /*#__PURE__*/React.createElement(FlexItem, Object.assign({
        isBlock: true,
        key: _key
      }, child.props, ui.$('Spacer')));
    }

    return child;
  });
  var classes = useMemo(function () {
    var _css;

    return cx(css((_css = {}, _css[ui.createToken('HStackSpacing')] = ui.space(spacing), _css)), className);
  }, [className, spacing]);

  var propsForFlex = _objectSpread(_objectSpread(_objectSpread({
    className: classes,
    children: clonedChildren,
    direction: direction,
    justify: 'center'
  }, align), otherProps), {}, {
    gap: spacing
  });

  var flexProps = useFlex(propsForFlex);
  return flexProps;
}